<div class="container">
  <i class="pi pi-info-circle x-small" (click)="op.toggle($event)"></i>
  <p-overlayPanel #op>
    <div class="version-data flex flex-column text-sm">
      <div class="text-white-600"><span class="font-bold">גרסה: </span>{{ curBuild }}</div>
      <div class="text-white-600"><span class="font-bold">סביבה: </span>{{ curEnv }}</div>
      <div class="text-white-600"><span class="font-bold">פרטים נוספים: </span></div>
      <div class="text-white-600 mr-3">{{ curGitBranch }}</div>
      <div class="text-white-600 mr-3">{{ curMessage }}</div>
      <div class="text-white-600 mr-3">{{ curTimestamp | date: "d/MM/yyyy H:mm"}}</div>
    </div>
  </p-overlayPanel>
  <div class="pr-1">V: {{ curBuild }}&nbsp;|&nbsp;{{ curTimestamp | date: "d/MM/yyyy H:mm"}}</div>
</div>
